import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import React from 'react';
import Loader from './Loader/Loader';

export const AuthenticationGuard = ({ component }: { component: React.ComponentType }) => {
  const location = useLocation();
  
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loader />,
    loginOptions: {
      appState: {
        returnTo: location.pathname + location.search
      }
    }
  });

  return <Component />;
};
